<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/edit_container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exporter_process_container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<template>
  <go-back-link :text="$t('labels.go-back-link')" name="ae_production_basic_container_export_show_container_path" :params="{
    agro_exporter_process_id: agro_exporter_process_id,
    container_id: container_id
  }" />

  <bread-crumbs :labels="[module_name, agro_exporter_process?.name]" />

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200" v-if="container">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label :class="[
                'label-form',
                isInvalidLabel('container_request_code')
              ]">
                {{ $t("model.container.container_request_code") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model="container.container_request_code"
                  :class="['input-text', isInvalid('container_request_code')]" />
              </div>
            </div>
            <div class="sm:col-span-3"></div>
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('container_code')]">
                {{ $t("model.container.container_code") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model="container.container_code"
                  :class="['input-text', isInvalid('container_code')]" />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.customer") }}
              </label>
              <div class="mt-1">
                <select-form v-if="customers.length > 0" :options="customers" v-model="container.customer_id" />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.status") }}
              </label>
              <div class="mt-1">
                <container-status-selector v-model="container.status_id" />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.exportation") }}
              </label>
              <div class="mt-1">
                <select-form v-if="available_exportations.length > 0" :options="available_exportations"
                  v-model="container.exportation_id" label="booking_code" />
                <alert-warning v-else :warning_data="{
                  title: $t('labels.not_available_exportations')
                }" />
              </div>
            </div>
          </div>

          <div v-if="producers_organizations.length != 1" class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.provider") }}
              </label>
              <div class="mt-1">
                <!-- <template v-if="agro_exporter_process.intermediate">
                  <div class="content-data">
                    <ul :class="{ 'list-disc list-inside': selected_provider_names.length > 1 }">
                      <li v-for="provider in selected_provider_names" :key="provider">{{ provider }}</li>
                    </ul>
                  </div>
                </template>
                <template v-else> -->
                <select-form :options="producers_organizations" v-model="providers" :multiple="true" label="label" />
                <!-- </template> -->
              </div>
            </div>
          </div>
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.load_date") }}
              </label>
              <div class="mt-1">
                <date-form v-model="container.load_date" />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('week')]">
                {{ $t("model.container.week") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model.trim.number="container.week"
                  :class="['input-text', isInvalid('week')]" />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.packing_house_process") }}
              </label>
              <div class="mt-1">
                <select-form v-if="packing_house_processes.length > 1" :options="packing_house_processes"
                  v-model="packing_processes" multiple />
                <div class="content-data" v-else-if="packing_house_processes.length == 1">
                  {{ packing_house_processes[0].name }}
                </div>
              </div>
            </div>
          </div>
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.waybill") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model="container.waybill" class="input-text" />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.exporter_process_brand") }}
              </label>
              <div class="mt-1 grid grid-cols-1 sm:grid-cols-8">
                <div class="sm:col-span-2">
                  <dt class="mt-1">
                    <SwitchGroup as="div" class="flex items-center">
                      <Switch v-model="container.fixed_brand" :class="[
                        container.fixed_brand ? 'bg-lime-600' : 'bg-gray-200',
                        'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                      ]">
                        <span aria-hidden="true" :class="[
                          container.fixed_brand
                            ? 'translate-x-5'
                            : 'translate-x-0',
                          'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
                        ]" />
                      </Switch>
                      <SwitchLabel as="span" class="ml-3">
                        <span class="label-form">
                          {{ $t("model.container.fixed_brand") }}
                        </span>
                      </SwitchLabel>
                    </SwitchGroup>
                  </dt>
                </div>
                <div class="sm:col-span-6" v-if="container.fixed_brand">
                  <select-form v-if="brands.length > 1" :options="brands" v-model="container.exporter_process_brand_id" />
                  <div class="content-data" v-else-if="brands.length == 1">
                    {{ brands[0].name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" v-if="container">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.cols_package_groups") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model="container.cols_package_groups" class="input-text" />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.rows_package_groups") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model="container.rows_package_groups" class="input-text" />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.thermo_code") }}
              </label>
              <div class="mt-1">
                <input type="text" v-model="container.thermo_code" :class="['input-text', isInvalid('thermo_code')]" />
              </div>
            </div>

            <div class="sm:col-span-3" v-if="agro_exporter_package_wrappers.length > 0">
              <label class="label-form">
                {{ $t("model.exporter_process_container.agro_exporter_package_wrapper_id") }}
              </label>
              <div class="mt-1">
                <select-form v-if="agro_exporter_package_wrappers.length > 1" :options="agro_exporter_package_wrappers"
                  v-model="exporter_process_container.agro_exporter_package_wrapper_id" />
                <div class="content-data" v-else-if="agro_exporter_package_wrappers.length == 1">
                  {{ agro_exporter_package_wrappers[0].name }}
                </div>
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <template v-for="(export_sealing, index) in export_sealings" :key="export_sealing.id">
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("labels.container_sealing") }} {{ export_sealing.name }}
                </label>
                <div class="flex mt-1 relative">
                  <input type="text" v-model.trim="container_sealings[index].value"
                    :class="['input-text', isInvalid('value')]" />
                </div>
              </div>
            </template>
          </div>

          <!-- Atributos adicionales -->
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <container-attributes-input v-model="container_attribute_values" :attributes="exporter_process_container_attributes">
            </container-attributes-input>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.container.private_comments") }}
                <em class="text-sm text-green-800 bg-green-100 p-1 rounded-md">
                  {{ $t("model.container.describe_private_comments") }}
                </em>
              </label>
              <div class="mt-1">
                <textarea v-model="container.private_comments" rows="3" class="input-text-area" />
              </div>
            </div>
          </div>

          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <switch-form class="sm:col-span-6" v-model="add_comment" :label="$t('labels.edit_comment_label')" />
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.container.comments") }}
                <em class="text-sm text-red-800 bg-red-100 p-1 rounded-md">
                  {{ $t("model.container.describe_comments") }}
                </em>
              </label>
              <div class="mt-1">
                <textarea v-model="container.comments" rows="3" :disabled="!add_comment"
                  :class="['input-text-area', add_comment ? '' : 'bg-gray-100']" />
              </div>
            </div>
          </div>

          <!-- <div
            v-if="
              !agro_exporter_process.intermediate &&
              exporter_process_intermediates.length > 0
            "
            class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
          >
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.container.intermediate_process") }}
              </label>
              <div class="mt-1">
                <select-form
                  :options="exporter_process_intermediates"
                  v-model="container.intermediate_process_id"
                  :clearable="true"
                  label="label"
                />
                <em class="text-sm">{{ $t('model.container.intermediate_process_explanation') }}</em>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button @click.prevent="goToShowContainer()" :label="$t('labels.cancel_button')" />
          <span class="space-actions"></span>
          <success-button v-if="!proc_save_button" @click.prevent="updateContainer()" :label="$t('labels.save_button')" />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import moment from "moment";
import BasicContainerExportQRequester from "@/views/agro_exporter/requesters/production/basic_container_export/query.js";
import BasicContainerExportMCRequester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_container.js";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import ContainerStatusSelector from "@/components/views/agro_exporter/production/basic_container_export/ContainerStatusSelector.vue";
import ContainerAttributesInput from "@/components/views/agro_exporter/production/basic_container_export/ContainerAttributesInput.vue";

export default {
  name: "AEProductionBasicContainerExportNewContainer",
  components: {
    ContainerStatusSelector,
    Switch,
    SwitchGroup,
    SwitchLabel,
    ContainerAttributesInput
  },
  props: ["agro_exporter_process_id", "container_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      agro_exporter_process: {},
      container: null,
      available_exportations: [],
      agro_exporter_package_wrappers: [],
      container_statuses: [],
      container_attribute_values: [],
      exporter_process_container_attributes: [],
      customers: [],
      packing_house_processes: [],
      brands: [],
      add_comment: false,
      producers_organizations: [],
      provider_producer: {},
      provider_organization: {},
      original_packing_house_process_id: null,
      providers: [],
      export_sealings: [],
      container_sealings: [],
      exporter_process_intermediates: [],
      packing_processes: [],
      exporter_process_container: {
        agro_exporter_package_wrapper_id: null,
      }
    };
  },
  methods: {
    checkIntermediateProcess: function () {
      if (!this.agro_exporter_process.intermediate) return;
      if (this.manage_any_ae_process_intermediated) return;

      this.goToShowProcess();
    },
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainer();
      await this.fetchAvailableExportations();
      await this.fetchCustomers();
      await this.fetchExporterProcessBrands();
      await this.fetchExporterProcessContainerAttributes();
      await this.fetchAgroExporterPackageWrappers();
      await this.fetchPackingHouseProcesses();
      await this.fetchProducersOrganizations();
      await this.fetchExportSealings();
      // await this.fetchExporterProcessIntermediates();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response =
        await BasicContainerExportQRequester.fetchAgroExporterProcess(
          this.agro_exporter_process_id
        );
      this.agro_exporter_process = response.data;
      this.checkIntermediateProcess();
    },
    fetchContainer: async function () {
      let response = await BasicContainerExportMCRequester.fetchContainer(
        this.container_id
      );
      this.container = response.data;
      this.original_packing_house_process_id = response.data.packing_house_process_id;
      this.exporter_process_container = this.container?.exporter_process_container || {};
      this.container_attribute_values = response.data.container_attribute_values || {};
    },
    setProviders() {
      this.container.container_providers.forEach(cp => {
        let prov = this.producers_organizations.find(
          po =>
            po.producer_id == cp.provider_producer_id &&
            po.organization_id == cp.provider_organization_id
        );
        if (prov) this.providers.push(prov.id);
      });
    },
    fetchAvailableExportations: async function () {
      let response =
        await BasicContainerExportMCRequester.fetchAvailableToAssignExportations(
          this.agro_exporter_process_id
        );
      this.available_exportations = response.data;
    },
    fetchCustomers: async function () {
      let response = await BasicContainerExportQRequester.fetchCustomers(
        this.agro_exporter_process_id
      );
      this.customers = response.data;
    },
    fetchExporterProcessBrands: async function () {
      let response =
        await BasicContainerExportQRequester.fetchExporterProcessBrands(
          this.agro_exporter_process_id
        );
      this.brands = response.data;
      if (this.brands.length == 1)
        this.container.exporter_process_brand_id = this.brands[0].id;
    },
    fetchExporterProcessContainerAttributes: async function () {
      let response = await BasicContainerExportQRequester.fetchExporterProcessContainerAttributes( this.agro_exporter_process_id);
      this.exporter_process_container_attributes = response.data;
    },
    fetchAgroExporterPackageWrappers: async function () {
      let response =
        await BasicContainerExportQRequester.fetchAgroExporterPackageWrappers(
          this.agro_exporter_process_id
        );
      this.agro_exporter_package_wrappers = response.data;
      if (this.agro_exporter_package_wrappers.length == 1)
        this.exporter_process_container.agro_exporter_package_wrapper_id = this.agro_exporter_package_wrappers[0].id;
    },
    fetchPackingHouseProcesses: async function () {
      let response =
        await BasicContainerExportQRequester.fetchPackingHouseProcesses(
          this.agro_exporter_process_id
        );
      this.packing_house_processes = response.data;
      this.setPackingProcesses();
      if (this.packing_house_processes.length == 1)
        this.packing_processes = [this.packing_house_processes[0].id];
    },
    setPackingProcesses() {
      this.packing_processes = this.container.container_packing_processes.map(
        container_packing_process => container_packing_process.packing_house_process_id
      );
    },
    fetchProducersOrganizations: async function () {
      let response =
        await BasicContainerExportQRequester.fetchProducersOrganizations(
          this.agro_exporter_process_id
        );
      this.producers_organizations = response.data;
      this.setProviders();
      if (this.producers_organizations.length == 1) {
        this.providers = [this.producers_organizations[0].id];
      }
    },
    fetchExportSealings: async function () {
      const response = await BasicContainerExportQRequester.fetchExportSealings(
        this.agro_exporter_process_id
      );
      this.export_sealings = response.data;

      this.container_sealings = this.export_sealings.map(export_sealing => {
        const container_sealing = this.container.container_sealings.find(
          container_sealing =>
            container_sealing.export_sealing_id == export_sealing.id
        );
        return {
          export_sealing_id: export_sealing.id,
          value: container_sealing?.value
        };
      });
    },
    fetchExporterProcessIntermediates: async function () {
      let response =
        await BasicContainerExportQRequester.fetchExporterProcessIntermediates(
          this.agro_exporter_process_id
        );
      this.exporter_process_intermediates = response.data;
      this.exporter_process_intermediates.forEach(process => {
        process["label"] = process.agro_exporter.name + " - " + process.name;
      });
    },
    goToShowContainer: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_show_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    },
    filterPackingHouseProcessByProvider: function (entity, provider_id) {
      return this.packing_house_processes.filter(
        packing_house_process =>
          packing_house_process.entity_id ==
          this.producers_organizations.find(
            producer_organization =>
              producer_organization[entity] == provider_id
          ).entity_id
      );
    },
    updateContainer: async function () {
      this.proc_save_button = true;
      try {
        let response = await BasicContainerExportMCRequester.updateContainer(
          this.container_id,
          {
            container_code: this.container.container_code,
            container_request_code: this.container.container_request_code,
            customer_id: this.container.customer_id,
            load_date: this.container.load_date,
            exporter_process_brand_id: this.container.exporter_process_brand_id,
            fixed_brand: this.container.fixed_brand,
            packing_house_process_id: this.container.packing_house_process_id,
            rows_package_groups: this.container.rows_package_groups,
            cols_package_groups: this.container.cols_package_groups,
            exporter_process_container: {
              agro_exporter_package_wrapper_id: this.exporter_process_container?.agro_exporter_package_wrapper_id || null
            },
            waybill: this.container.waybill,
            comments: this.container.comments,
            exportation_id: this.container.exportation_id,
            status_id: this.container.status_id,
            private_comments: this.container.private_comments,
            provider_producer_id: this.container.provider_producer_id,
            provider_organization_id: this.container.provider_organization_id,
            container_providers: this.container_providers,
            thermo_code: this.container.thermo_code,
            intermediate_process_id: this.container.intermediate_process_id,
            container_sealings: this.container_sealings,
            container_attribute_values: this.container_attribute_values,
            container_packing_processes: this.packing_processes,
            week: this.container.week,
          }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowContainer();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    }
  },
  computed: {
    load_date_formatted: function () {
      return moment(this.container.load_date).format("YYYY-MM-DD");
    },
    container_providers: function () {
      return this.providers.map(id => {
        let prod_org = this.producers_organizations.find(
          option => option.id == id
        );

        let container_provider = {};
        if (prod_org.producer_id)
          container_provider["provider_producer_id"] = prod_org.producer_id;
        if (prod_org.organization_id)
          container_provider["provider_organization_id"] =
            prod_org.organization_id;

        return container_provider;
      });
    },
    manage_any_ae_process_intermediated: function () {
      return this.agro_exporter_process?.manage_any_ae_process_intermediated;
    },
    selected_provider_names: function () {
      return this.container.container_providers
        .map(cp => {
          const match = this.producers_organizations.find(po =>
            po.organization_id === cp.provider_organization_id ||
            po.producer_id === cp.provider_producer_id
          );
          return match?.label || null;
        })
        .filter(name => name);
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchData())
    );
  },
  watch: {
    "container.provider_producer_id": function () {
      let packing_house_processes = this.filterPackingHouseProcessByProvider(
        "producer_id",
        this.container.provider_producer_id
      );
      if (packing_house_processes.length > 0)
        this.container.packing_house_process_id = packing_house_processes[0].id;
    },
    "container.provider_organization_id": function () {
      let packing_house_processes = this.filterPackingHouseProcessByProvider(
        "organization_id",
        this.container.provider_organization_id
      );
      if (packing_house_processes.length > 0)
        this.container.packing_house_process_id = packing_house_processes[0].id;
    },
    "container.fixed_brand": function () {
      if (!this.container.fixed_brand) this.container.exporter_process_brand_id = null;
    },
  }
};
</script>
